import { useEffect, useState } from "react";

export const useYearMonth = (dispatch, accountsActions, handleCloseSearch, specialFilter) => {
    const currentYear = new Date().getFullYear().toString();
    const [selectedFilter, setSelectedFilter] = useState({ year: currentYear, month: "all" });

    useEffect(() => {
        dispatch(accountsActions.yearsMonthRequest());
        dispatch(accountsActions.setYearMonthFilter(selectedFilter));
    }, []);

    const handleChange = (option, key) => {
        setSelectedFilter((state) => ({ ...state, [key]: option.value }));
    };

    const handleSearch = () => {
        dispatch(accountsActions.setYearMonthFilter(selectedFilter));
        if (specialFilter) {
            handleCloseSearch();
        }
    };
    const handleReset = () => {
        setSelectedFilter({ year: currentYear, month: "all" });
    };

    return { selectedFilter, handleChange, handleSearch, handleReset };
};

export default useYearMonth;
